import React, { memo, useEffect, useState } from 'react';

import { Alert, App, Button, Modal, Typography } from 'antd';

import { useMutation } from '@tanstack/react-query';
import apiService from 'v2/services/api';

export const MODAL_NEWS_RVP_DISABLED = true;

export interface ModalNewsRVPProps {
  available?: boolean;
  disabled?: boolean;
}

export const ModalNewsRVP = memo(({ available, disabled = MODAL_NEWS_RVP_DISABLED }: ModalNewsRVPProps) => {
  const { message } = App.useApp();
  const [opened, setOpened] = useState(false);

  const disabledInThisSession = !!sessionStorage.getItem('disabled-products-without-rvp');

  const activate = useMutation({
    mutationFn: () => apiService.put('/products-without-rvp/activate', {}).toPromise(),
    onSuccess: () => {
      message.success('Ativação realizada com sucesso!');
      setOpened(false);
    },
    onError: () => {
      message.error('Não foi possível ativar o RVP.');
    }
  });

  const deny = useMutation({
    mutationFn: () => apiService.put('/products-without-rvp/deny', {}).toPromise(),
    onSuccess: () => {
      message.success('Preferência registrada.');
      setOpened(false);
    },
    onError: () => {
      message.error('Não foi possível registrar sua escolha.');
    }
  });

  const isPending = activate.isPending || deny.isPending;

  const handleActivate = () => {
    activate.mutate();
  };

  const handleDeny = () => {
    deny.mutate();
  };

  const handleClose = () => {
    sessionStorage.setItem('disabled-products-without-rvp', 'true');
    setOpened(false);
  };

  useEffect(() => {
    setOpened(true);
  }, []);

  return (
    <Modal
      open={opened && available && !disabled && !disabledInThisSession}
      onCancel={handleClose}
      maskClosable={false}
      title='Temos uma ferramenta poderosa e totalmente gratuita para você aproveitar!'
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button type='text' onClick={handleClose} disabled={isPending}>
            Agora não
          </Button>
          <Button onClick={handleDeny} loading={deny.isPending} disabled={isPending}>
            Não quero ativar
          </Button>
          <Button type='primary' onClick={handleActivate} loading={activate.isPending} disabled={isPending}>
            Sim, ativar RVP!
          </Button>
        </div>
      }
    >
      <div className='flex flex-col gap-4'>
        <Alert
          type='info'
          showIcon
          message='Recuperação de Vendas Perdidas (RVP)'
          description={
            <>
              Já está disponível para você, mas ainda não está ativa em seus produtos. Recupere vendas não finalizadas e
              aumente sua conversão em até <Typography.Text strong>15%</Typography.Text> sem esforço!
            </>
          }
        />
        <Typography.Paragraph className='mb-0'>
          <Typography.Text strong>Que tal ativar agora?</Typography.Text> Ao ativar, a RVP passa a valer nos seus
          produtos elegíveis. Se preferir, você pode recusar a ativação.
        </Typography.Paragraph>
        <Typography.Text type='secondary' italic>
          Você pode alterar essa configuração a qualquer momento na edição de cada produto.
        </Typography.Text>
      </div>
    </Modal>
  );
});
